import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import MessagingService from '../services'
import {
	GetMessageTransactionHistoryRequest,
	GetMessageTransactionHistoryResponse,
} from '../../types'

function useQueryGetMessageHistory(
	payload: GetMessageTransactionHistoryRequest,
	props?: UseBaseQueryOptions<GetMessageTransactionHistoryResponse>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetMessageTransactionHistory, payload],
		queryFn: () => MessagingService.getMessageTransactionHistory(payload),
		...props,
	})
}

export default useQueryGetMessageHistory
